import { render, staticRenderFns } from "./GapComponent.vue?vue&type=template&id=6a212df7&scoped=true"
import script from "./GapComponent.vue?vue&type=script&lang=js"
export * from "./GapComponent.vue?vue&type=script&lang=js"
import style0 from "./GapComponent.vue?vue&type=style&index=0&id=6a212df7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a212df7",
  null
  
)

export default component.exports